import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  log(message: string, ...messages: any) {
    console.log(message, messages);
  }
  error(message: string, ...messages: any) {
    console.error(message, messages);
  }
}
